import React from "react";
import ReactDOM from "react-dom/client";
import { Provider } from "react-redux";
import store from "./store";
import "./index.css";
import App from "./App";
import * as serviceWorker from "./serviceWorker";
import axios from "axios";

axios.interceptors.response.use(
  (response) => response,
  (error) => {
    if (error?.response?.status === 412 && error?.response?.data?.message === "PASSWORD_CHANGE_REQUIRED") {
      const user = JSON.parse(localStorage.getItem("user"));
      if (user) {
        localStorage.setItem("user", JSON.stringify({ ...user, passwordChangeRequired: true }));
        if (window.location.pathname !== "/change-password") {
          window.location.href = "/change-password";
        }
      }
    }
    return Promise.reject(error);
  }
);

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <Provider store={store}>
    <App />
  </Provider>
);

// If you want your app to work offline and load faster, you can chađinge
// unregister() to register() below. Note this comes with some pitfalls.
// Learn more about service workers: https://bit.ly/CRA-PWA
serviceWorker.unregister();